import { TFunction } from "i18next";
import { cn } from "~/utils/utils";
import { boxClassName } from ".";

type HeadersProps = {
  t: TFunction;
};

export function Headers({ t }: HeadersProps) {
  return (
    <div className="flex flex-col gap-2">
      <ImageHeaders />
      <div className="grid grid-cols-3 w-full justify-between gap-2">
        <Header children={""} />
        <Header children={t("Basic (incl. VAT) Max. 3 charging points)")} />
        {/* <SponsoredHeader t={t} /> */}
        <Header children={t("Commercial (excl. VAT)")} />
      </div>
    </div>
  );
}

function ImageHeaders() {
  const images = [
    "",
    "/assets/home.svg",
    // "/assets/sponsored.svg",
    "/assets/commercial.svg",
  ];

  return (
    <div className="flex justify-between">
      {images.map((src, index) =>
        index === 0 ? (
          <div
            key={`tier-header-placeholder-${index}`}
            className="flex flex-row justify-center w-full"
          />
        ) : (
          <div
            key={`tier-header-${index}`}
            className="flex flex-row justify-center w-full"
          >
            {src && (
              <img src={src} className="size-14 bg-gray-200 rounded-full" />
            )}
          </div>
        )
      )}
    </div>
  );
}

// function SponsoredHeader({ t }: HeadersProps) {
//   return (
//     <div className="col-span-2 flex flex-col gap-2">
//       <Header children={t("Sponsored (excl. VAT)")} />
//       <div className="flex flex-row gap-2">
//         <Header children={t("Employee")} />
//         <Header children={t("Employer")} />
//       </div>
//     </div>
//   );
// }

type HeaderProps = {
  children: React.ReactNode;
};

function Header({ children }: HeaderProps) {
  return (
    <div
      className={cn(
        boxClassName,
        "bg-ev-500 text-xs w-full text-white font-semibold"
      )}
      children={children}
    />
  );
}
